import {
  JbPopup
} from "./chunk.JRI6TUXF.js";
import {
  JbI18nData
} from "./chunk.TVHPUHP2.js";
import {
  jb_cookie_consent_css_default
} from "./chunk.4NURFD3O.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  JBCookie,
  mergeDeep
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-cookie-consent/jb-cookie-consent.ts
var JbCookieConsent = class extends Initiable(i) {
  constructor() {
    super(...arguments);
    this._open = false;
  }
  static create(data) {
    return new JbCookieConsent().init({ props: data, childNodes: [] });
  }
  connectedCallback() {
    super.connectedCallback();
    this.dispatchEvent(
      new CustomEvent("jb-cookie-consent:connected", {
        bubbles: true,
        composed: true,
        detail: { element: this }
      })
    );
    if (!JbCookieConsent._linkHandlerBound) {
      JbCookieConsent._linkHandlerBound = true;
      this._bindLinkHandler();
    }
  }
  willUpdate(changedProperties) {
    if (changedProperties.has("country")) {
      this._languageSelectOptions = void 0;
    }
  }
  updated(changedProperties) {
    if (changedProperties.has("_open")) {
      this.toggleAttribute("open", this._open);
      if (this._open) {
        this.dispatchEvent(
          new CustomEvent("jb-cookie-consent:open", {
            bubbles: true,
            composed: true
          })
        );
      }
    }
  }
  close() {
    this._open = false;
  }
  async firstUpdated() {
    window.setTimeout(() => {
      this._prepareCookieSettingsComponent().then();
    }, 50);
    await this.updateComplete;
    dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
  }
  getCookieSettings() {
    return this._cookieSettingsComponent;
  }
  open() {
    this._open = true;
  }
  showCookieSettingsPopup() {
    if (!this._cookieSettingsComponent) {
      return;
    }
    this.dispatchEvent(
      new CustomEvent("jb-popup:transition", {
        bubbles: true,
        composed: true,
        detail: {
          nextChild: this._cookieSettingsComponent
        }
      })
    );
  }
  _bindLinkHandler() {
    document.body.addEventListener("jb-link:clicked", (event) => {
      const customEvent = event;
      if (!customEvent.detail.cookieSettings) {
        return;
      }
      customEvent.stopPropagation();
      customEvent.detail.clickEvent.preventDefault();
      customEvent.detail.clickEvent.stopPropagation();
      const originalCookieConsent = document.querySelector(
        "jb-cookie-consent:not([data-clone])"
      );
      if (!originalCookieConsent) {
        return;
      }
      new JbPopup().init({
        childNodes: [originalCookieConsent.getCookieSettings()],
        props: {
          returnFocusTo: customEvent.detail.linkTag,
          ariaLabels: {
            label: customEvent.detail?.overlayAriaLabels?.label
          }
        }
      }).stack();
    });
  }
  _getLanguageOptions() {
    const i18nDataComponent = JbI18nData.find();
    if (!i18nDataComponent) {
      return [];
    }
    return i18nDataComponent.getI18nDataLanguageOptionsForCountry(this.country || "");
  }
  _getLanguageSelectOptions() {
    if (!this._languageSelectOptions) {
      const i18nDataComponent = JbI18nData.find();
      if (!i18nDataComponent) {
        return [];
      }
      const languageOptions = this._getLanguageOptions();
      this._languageSelectOptions = [];
      languageOptions?.forEach((languageOption) => {
        const language = i18nDataComponent.getLanguageByIsoCode(languageOption.language);
        if (!language) {
          return;
        }
        this._languageSelectOptions.push({
          label: language.shortLabel || language.label,
          value: languageOption.language
        });
      });
    }
    return this._languageSelectOptions;
  }
  _handleButtonClick(button, event) {
    event.preventDefault();
    event.stopPropagation();
    if (button.setsConsentFor) {
      this._cookieSettingsComponent?.setConsentFor(button.setsConsentFor);
    }
    if (button.opensCookieSettings) {
      this.showCookieSettingsPopup();
    } else {
      this._saveLanguageSelection();
      JBCookie.deleteCookie("allow_tracking_cookies");
      JBCookie.deleteCookie("allow_marketing_cookies");
      JBCookie.setCookie("hide_cookie_banner", "1");
      JBCookie.setCookie("show_cookie_banner", "0");
      JBCookie.setCookie("cookie_banner_suppressed", "0");
      this.dispatchEvent(new CustomEvent("jb-popup:close", { bubbles: true, composed: true }));
    }
  }
  _handleFocusOnSection() {
    this.renderRoot.querySelector("jb-dropdown .ts-control")?.focus();
  }
  _handleKeyboardEvent(evt) {
    const target = evt.target;
    switch (evt.code) {
      case "Space":
        if (target.tagName === "JB-RICHTEXT" || target.tagName === "A") {
          evt.preventDefault();
          break;
        }
        break;
      default:
        break;
    }
  }
  _handleLanguageChange(event) {
    event.stopPropagation();
    if (event.detail.newValue && event.detail.newValue !== this._selectedLanguage) {
      this._selectedLanguage = event.detail.newValue;
      this._prepareCookieSettingsComponent().then();
    }
  }
  async _prepareCookieSettingsComponent() {
    const currentLanguage = this._selectedLanguage || this.currentLanguageIso2;
    const effectiveCookieSettings = mergeDeep(
      {},
      this.cookieSettingsPerLanguage.__default,
      this.cookieSettingsPerLanguage[currentLanguage]
    );
    const { JbCookieSettings } = await import("../components/jb-cookie-settings/jb-cookie-settings.js");
    this._cookieSettingsComponent = JbCookieSettings.create(effectiveCookieSettings);
  }
  _saveLanguageSelection() {
    if (!this._selectedLanguage || this._selectedLanguage === this.currentLanguageIso2) {
      return;
    }
    this.dispatchEvent(
      new CustomEvent("jb-cookie-consent:language-changed", {
        bubbles: true,
        composed: true,
        detail: { languageIso2: this._selectedLanguage }
      })
    );
    const selectedOption = this._getLanguageOptions().find(
      (languageOption) => languageOption.language === this._selectedLanguage
    );
    if (!selectedOption) {
      return;
    }
    window.location.href = selectedOption.url;
  }
  render() {
    const languageOptions = this._getLanguageSelectOptions();
    const currentLanguage = this._selectedLanguage || this.currentLanguageIso2 || (languageOptions?.length ? languageOptions[0].value : void 0) || "";
    const content = this.content[currentLanguage] || this.content.__default;
    const headline = this.headlineLabels[currentLanguage] || this.headlineLabels.__default;
    if (!this._open) {
      return b``;
    }
    if (this.buttons) {
      import("../components/jb-button-panel/jb-button-panel.js").then();
    }
    this.buttons.forEach((button) => {
      if (button.isPrimaryAction) {
        import("../components/jb-button-primary/jb-button-primary.js").then();
      } else {
        import("../components/jb-button-secondary/jb-button-secondary.js").then();
      }
    });
    if (languageOptions && languageOptions.length > 0) {
      import("../components/jb-dropdown/jb-dropdown.js").then();
    }
    return b`
      <section
        @keydown=${this._handleKeyboardEvent}
        aria-modal="true"
      >
        <div
          class="container"
          @focus=${this._handleFocusOnSection}
          tabindex="0"
        >
          ${languageOptions && languageOptions.length > 0 ? b`
                  <jb-dropdown
                    @jb-select:changed=${this._handleLanguageChange}
                    inverted
                    .options=${languageOptions}
                    .value=${currentLanguage}
                    showLabel
                    label="${this.languageSelectLabels[currentLanguage] || this.languageSelectLabels.__default}"
                  ></jb-dropdown>
                ` : A}
          <div class="text-container">
            ${headline ? b`<jb-heading
                    class="headline"
                    rank="1"
                    >${headline}</jb-heading
                  >` : A}
            <jb-richtext .size=${"small"}>${o(content)}</jb-richtext>
            <jb-button-panel>
              ${this.buttons.map(
      (button) => b`
                  ${button.isPrimaryAction ? b`
                          <jb-button-primary
                            @click=${this._handleButtonClick.bind(this, button)}
                            inverted
                          >
                            ${button.labels[currentLanguage] || button.labels.__default}
                          </jb-button-primary>
                        ` : b`
                          <jb-button-secondary
                            @click=${this._handleButtonClick.bind(this, button)}
                            inverted
                          >
                            ${button.labels[currentLanguage] || button.labels.__default}
                          </jb-button-secondary>
                        `}
                `
    )}
            </jb-button-panel>
          </div>
        </div>
      </section>
    `;
  }
};
JbCookieConsent.styles = [reset_css_default, jb_cookie_consent_css_default];
JbCookieConsent.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
JbCookieConsent._linkHandlerBound = false;
__decorateClass([
  n({ type: Array })
], JbCookieConsent.prototype, "buttons", 2);
__decorateClass([
  n({ type: Object })
], JbCookieConsent.prototype, "content", 2);
__decorateClass([
  n({ type: Object })
], JbCookieConsent.prototype, "cookieSettingsPerLanguage", 2);
__decorateClass([
  n()
], JbCookieConsent.prototype, "country", 2);
__decorateClass([
  n()
], JbCookieConsent.prototype, "currentLanguageIso2", 2);
__decorateClass([
  n({ type: Object })
], JbCookieConsent.prototype, "headlineLabels", 2);
__decorateClass([
  n({ type: Object })
], JbCookieConsent.prototype, "languageSelectLabels", 2);
__decorateClass([
  n({ type: Boolean })
], JbCookieConsent.prototype, "showOnPageLoad", 2);
__decorateClass([
  r()
], JbCookieConsent.prototype, "_open", 2);
__decorateClass([
  r()
], JbCookieConsent.prototype, "_selectedLanguage", 2);
JbCookieConsent = __decorateClass([
  customElement("jb-cookie-consent")
], JbCookieConsent);

export {
  JbCookieConsent
};
